import type { Avatar as AvatarType } from './types';
import { memo } from 'react';
import { Avatar, Body, P, Stack, Tooltip } from '@workramp/ui';
import { useTheme } from 'styled-components';
import { getColorsForAvatar, getLettersForAvatar } from '~/utils/avatar';
import { Wrapper, AvatarsContainer, AvatarWrapper, OverflowAvatarWrapper } from './AvatarStack.styles';

export interface AvatarStackProps {
  avatars: AvatarType[];
  limit?: number;
  brandColor?: string;
  showOverflow?: boolean;
}

export const AvatarStack = memo(({ avatars, limit = 3, brandColor, showOverflow }: AvatarStackProps) => {
  const theme = useTheme();
  const colors = getColorsForAvatar(theme, brandColor);

  const visibleAvatars = avatars.slice(0, limit);
  const overflowAvatars = avatars.slice(limit);

  return (
    <Wrapper>
      <AvatarsContainer>
        {visibleAvatars.map((avatar) => {
          const isGeneric = Number.isNaN(+avatar.id);

          return (
            <Tooltip key={avatar.id} message={avatar.name}>
              <AvatarWrapper>
                <Avatar
                  imgUrl={avatar.imgUrl}
                  letters={!isGeneric ? getLettersForAvatar(avatar.name) : undefined}
                  {...colors}
                  {...avatar}
                />
              </AvatarWrapper>
            </Tooltip>
          );
        })}
      </AvatarsContainer>
      {showOverflow && overflowAvatars.length > 0 && (
        <Tooltip
          message={
            <Stack size={2}>
              {overflowAvatars.map((avatar) => {
                const isGeneric = Number.isNaN(+avatar.id);
                return (
                  <OverflowAvatarWrapper key={avatar.id}>
                    <Avatar
                      imgUrl={avatar.imgUrl}
                      letters={!isGeneric ? getLettersForAvatar(avatar.name) : undefined}
                      {...colors}
                      {...avatar}
                    />
                    <Body level="md">{avatar.name}</Body>
                  </OverflowAvatarWrapper>
                );
              })}
            </Stack>
          }
        >
          <P size={1}>+{overflowAvatars.length}</P>
        </Tooltip>
      )}
    </Wrapper>
  );
});
